module.exports = __webpack_public_path__ + "assets/support.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/support.png
// module id = 1224
// module chunks = 7